import { useState } from "react";
import { AccessibilityInfo } from "react-native";

import { Chip } from "../primitives/Chip";
import type { UiTheme } from "../theme";

// The set table's reveal chips (HI-1 «Time», #336 S3 «Range», HI-8 «Pause»):
// a lines-under-each-set part opens by the author's tap OR because a set
// already holds a value, so opening a stored program shows it. The chip then
// unmounts: it reveals, it never closes. One place for the rule.

/** `enabled`: the host offers this part at all. `stored`: a set already has it. */
export function useRevealChip(enabled: boolean, stored: boolean) {
  const [toggled, setToggled] = useState(false);
  return { open: enabled && (toggled || stored), reveal: () => setToggled(true) };
}

/** The chip that opens the part. Render it only while the part is closed. */
export function RevealChip({
  theme,
  label,
  a11yLabel,
  announce,
  onReveal,
}: {
  theme: UiTheme;
  label: string;
  a11yLabel: string;
  /** Said once the chip is gone, so the reader learns what appeared. */
  announce?: string;
  onReveal: () => void;
}) {
  return (
    <Chip
      theme={theme}
      dense
      shape="pill"
      label={label}
      // ⛔ No `expanded`: it reveals and then unmounts itself. Announcing
      // "collapsed" would promise a later "expanded" that never comes.
      onPress={() => {
        if (announce) AccessibilityInfo.announceForAccessibility(announce);
        onReveal();
      }}
      accessibilityLabel={a11yLabel}
    />
  );
}
